import axios from "../utils/axios";
import useAuth from "./useAuth";

const useLogout = () => {
    const { setAuth } = useAuth();

    const logout = async () => {
        setAuth({});
        try {
             await axios.post('auth/token/logout/', {
                "refresh_token": localStorage.getItem("refreshToken")
            });
        } catch (err) {
            console.error(err);
        }
    }

    return logout;
}

export default useLogout